import { BOMItemType } from '../../../constants/bom-item-type.js';
/** Note and Service lines are informational only and have nothing to link — every other type must name a real Part. */
export const BOM_ITEM_TYPES_REQUIRING_PART = new Set([
    BOMItemType.RAW_GOOD,
    BOMItemType.FINISHED_GOOD,
    BOMItemType.REPAIR,
]);
//# sourceMappingURL=bom-item-types-requiring-part.js.map